import { render, staticRenderFns } from "./dili-uploadfile.vue?vue&type=template&id=5df04f3e&scoped=true&"
import script from "./dili-uploadfile.vue?vue&type=script&lang=js&"
export * from "./dili-uploadfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df04f3e",
  null
  
)

export default component.exports